module.exports = __webpack_public_path__ + "static/HaloDao-399ada3f785af8247233acd9f2a8264d.jpg";